import { useInfiniteQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getContentListing } from "../../services/portalAluno/contentListing/contentListingService";
import { PORTAL_LISTING_PAGE_SIZE } from "../../config/portalAluno/constants";
import type {
  ContentListingPageData,
  ContentSectionConfig,
  ContentUploadWindow,
} from "../../@types/portalAluno";
import type { ApplicationState } from "../../store";

export const portalContentListingQueryKey = (
  idUsuario?: number,
  apiType?: string,
  uploadWindow?: ContentUploadWindow | null
) => ["portal-aluno", "listagem", idUsuario, apiType, uploadWindow ?? "todos"];

const useContentListing = (
  section?: ContentSectionConfig,
  uploadWindow?: ContentUploadWindow | null
) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useInfiniteQuery<ContentListingPageData>({
    enabled: Boolean(section && idUsuario),
    queryKey: portalContentListingQueryKey(idUsuario, section?.apiType, uploadWindow),
    queryFn: ({ pageParam = 0 }) =>
      getContentListing(section as ContentSectionConfig, pageParam, uploadWindow),
    getNextPageParam: (lastPage, allPages) => {
      if (
        !section?.paginated ||
        lastPage.itemCount < PORTAL_LISTING_PAGE_SIZE
      ) {
        return undefined;
      }

      return allPages.length * PORTAL_LISTING_PAGE_SIZE;
    },
  });
};

export default useContentListing;
